import React, { useState, useEffect } from "react";
import { Button } from "primereact/button";
import SwitchConInput from "./fields/SwitchConInput";
import SwitchConNInput from "./fields/SwitchConNInput";
import ListaToggleButton from "./fields/ListaToggleButton";

const Bagno = (props) => {
  
  //console.log("props?.preventivo?.bagni[props.indice]", props?.preventivo?.bagni[props.indice]);
  const [bagno, setBagno] = useState(
    props?.preventivo?.bagni[props.indice] || {
      title: "Bagno",

      // posa PAVIMENTI DI OGNI GENERE
      puntiAcqua: {
        tipologia: "ListaToggleButton",
        titolo: "Realizzazione impianto idraulico",
        descrizione: `Pianificazione e progettazione, preparazione del sito, installazione delle tubazioni, installazione dei dispositivi di controllo e regolazione,collegamento alla rete idrica della casa, verifica e collaudo, non comprende installazione sanitari previsto allo step installazioni`,
        valore: [
          { nome: "Lavandino", num: 0, prezzo: 220 },
          { nome: "Bidet", num: 0, prezzo: 220 },
          { nome: "Doccia", num: 0, prezzo: 220 },
          { nome: "Lavatoio", num: 0, prezzo: 220 },
          { nome: "Vasca", num: 0, prezzo: 220 },
          { nome: "Wc", num: 0, prezzo: 220 },
        ],
        ancheInput: true,
        descrizioneInput: "N. altri punti non elencati",
        quantitaAncheInput: 0,
        prezzoAncheInput: 100,
        descQuantita: "num",
        prezzoFinale: 0,
      },
      // rimozione pavimento
      rimozionePavimento: {
        tipologia: "SwitchConInput",
        titolo: "Demolizione pavimento",
        descrizione: "Demolizione pavimento  compresa colla",
        valore: false,
        descrizioneQuantita: "A corpo",
        descQuantita: "u",
        quantita: 0,
        prezzo: 200,
      },
      // rimozione pavimento
      // rivestimenti gres
      demolizioneRivestimentoPareteGres: {
        tipologia: "SwitchConInput",
        titolo: "Demolizione rivestimento a parete in ceramica/gres",
        descrizione: `Demolizione di rivestimento a parete in ceramica/gres`,
        valore: false,
        descrizioneQuantita: "Metri quadrati",
        descQuantita: "mq",
        quantita: 0,
        prezzo: 25,
      },
      // demolizione sottofondo
      demolizioneSottofondo: {
        tipologia: "SwitchConInput",
        titolo: "Demolizione di sottofondo in malta cementizia",
        descrizione: `Demolizione di sottofondo in malta cementizia per permettere una migliore esecuzione degli impianti fino a 5 cm di spessore`,
        valore: false,
        descrizioneQuantita: "a corpo",
        descQuantita: "u",
        quantita: 0,
        prezzo: 300,
      },
      // rimozione impianto elettrico
      rimozioneImpiantoElettrico: {
        tipologia: "SwitchConInput",
        titolo: "Rimozione impianto elettrico",
        descrizione: `Valutazione iniziale, smontaggio apparecchiature elettriche, rimozione dei cavi elettrici, ispezione e verifica, ripristino delle pareti e dei pavimenti`,
        valore: false,
        descrizioneQuantita: "Numero punti luce",
        descQuantita: "u",
        quantita: 0,
        prezzo: 100,
        extra: {
          descrizione: 'Assistenza impianto elettrico',
          //percentuale: 50
        }
      },

      // rimozione impianto idraulico
      rimozioneImpiantoIdraulico: {
        tipologia: "SwitchConInput",
        titolo: "Rimozione impianto idraulico",
        descrizione: ` Valutazione iniziale, smontaggio apparecchiature elettriche, rimozione dei cavi elettrici, ispezione e verifica, ripristino delle pareti e dei pavimenti`,
        valore: false,
        descrizioneQuantita: "Numero punti acqua",
        descQuantita: "n",
        quantita: 0,
        prezzo: 100,
        extra: {
          descrizione: 'Assistenza impianto idraulico',
          //percentuale: 50
        }
      },
      posaPavimentoRivestimento: {
        tipologia: "SwitchConNInput",
        titolo: "Posa pavimenti e/o rivestimenti di ogni genere ",
        descrizione: `Posa pavimenti e/o di ogni genere (parquet, gres, PVC) compresa colla`,
        valore: false,
        prezzoFinale: 0,
        valoriInput: [
          {
            nome: "Legno Parquet",
            descrizione: "Metri quadri pavimento legno parquet",
            descQuantita: "mq",
            quantita: 0,
            prezzo: 40,
          },
          {
            nome: "Gres",
            descrizione: "Metri quadri pavimento gres",
            descQuantita: "mq",
            quantita: 0,
            prezzo: 40,
          },
          {
            nome: "PVC",
            descrizione: "Metri quadri pavimenti PVC",
            descQuantita: "mq",
            quantita: 0,
            prezzo: 25,
          },
        ],
      },
      intonacatura: {
        tipologia: "SwitchConInput",
        titolo: "Intonacatura",
        descrizione:
          "Esecuzione di intonaco  per interni su pareti dove prima era presente rivestimento.Finitura a gesso, applicata per uno spessore non inferiore a 3 mm",
        valore: false,
        descrizioneQuantita: "Metri quadri",
        descQuantita: "mq",
        quantita: 0,
        prezzo: 25,
      },
      // imbiancatura
      imbiancatura: {
        tipologia: "SwitchConInput",
        titolo: "Imbiancatura",
        descrizione:
          "Preparazione delle superfici, Protezione di eventuali arredi e delle aree circostanti, scelta della vernice, applicazione della vernice",
        valore: false,
        descrizioneQuantita: "Metri quadri",
        descQuantita: "mq",
        quantita: 0,
        prezzo: 15,
      },

    }
  );

  useEffect(() => {
    
    props.onChange(bagno, props.indice);
  }, [bagno]);

  const divider = (
    <div className="surface-border border-top-1 opacity-50 mb-3 col-12"></div>
  );
  return (
    <>
      
          <div className="grid formgrid p-fluid">
            
            {Object.keys(bagno).map((key) => (
              <React.Fragment key={key}>
                {bagno[key].tipologia === "SwitchConInput" && (
                  <>
                  <SwitchConInput
                    field={bagno[key]}
                    onChange={(data) => {
                      setBagno({ ...bagno, [key]: data });
                    }}
                  />
                  {divider}
                  </>
                )}
                {bagno[key].tipologia === "SwitchConNInput" && (
                 <>
                 <SwitchConNInput
                    field={bagno[key]}
                    onChange={(data) => {
                      setBagno({ ...bagno, [key]: data });
                    }}
                  />
                  {divider}
                  </>
                )}
                {bagno[key].tipologia === "ListaToggleButton" && (
                  <>
                  <ListaToggleButton
                    field={bagno[key]}
                    onChange={(data) => {
                      setBagno({ ...bagno, [key]: data });
                    }}
                  />
                  {divider}
                  </>
                )}
      
              </React.Fragment>
            ))}
          </div>
          {props.indice != 0 && 
          <Button type="button" label="Rimuovi bagno"  className="px-5 py-3 w-auto" onClick={()=>props.handleRimuoviBagno(props.indice)}  />
        }
        
      
    </>
  );
};
export default Bagno;
